import React from 'react';
import { Link } from 'gatsby';
import './Breadcrumb.scss';

const Breadcrumb = ({ location: { pathname } }) => {
    const path = pathname.split('/').filter(subpath => (subpath !== ''));
    return (
        <div className="breadcrumb">
            {path.map((subpath, index) => {
                return (
                    <span key={subpath}>
                        {(index !== path.length - 1) && (
                            <span className="breadcrumb-group">
                                <Link
                                    className="breadcrumb-path"
                                    to={`/${path.slice(0, index + 1).join("/")}`}
                                >
                                    {subpath}
                                </Link>
                            </span>
                        )}
                        {index === path.length - 1 && (
                            <span className="breadcrumb-group">
                                <span className="breadcrumb-current-location">{subpath}</span>
                            </span>
                        )}
                        <span className="breadcrumb-group">
                            <span className="breadcrumb-divider">/</span>
                        </span>
                    </span>
                );
            })}
        </div>
    )
};

export default Breadcrumb;
